export default "__VITE_ASSET__Duxu7uWQ__"